"use client";

import { openCookieConsentSettings } from "@/lib/analytics-consent";

export function CookieSettingsButton() {
  return (
    <button
      type="button"
      onClick={openCookieConsentSettings}
      className="mt-5 inline-flex min-h-11 items-center justify-center rounded-sm border border-[#273E47]/25 bg-[#273E47] px-5 py-2.5 text-sm font-black uppercase tracking-[0.08em] text-white transition hover:bg-[#1F323A] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#A4243B] focus-visible:ring-offset-2"
    >
      Cookie beállítások módosítása
    </button>
  );
}
